export interface PersonaOption {
  label: string
  value: string
}

export const GENDER_OPTIONS: PersonaOption[] = [
  { label: 'Select a Gender', value: null },
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
  { label: 'Non-Binary', value: 'non-binary' },
]

export const SUFFIX_OPTIONS: PersonaOption[] = [
  { label: '', value: null },
  { label: 'Jr.', value: 'Jr.' },
  { label: 'Sr.', value: 'Sr.' },
  { label: 'I', value: 'I' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
]

export const DISABILITY_OPTIONS: PersonaOption[] = [
  { label: 'I have a disability', value: 'yes' },
  { label: 'I do not have a disability', value: 'no' },
  { label: 'I choose not to respond', value: 'non-binary' },
]

export const MILITARY_STATUS_OPTIONS: PersonaOption[] = [
  { label: 'Currently serving', value: 'active' },
  { label: 'I am a veteran', value: 'veteran' },
  { label: 'I am not a veteran', value: 'none' },
  { label: 'I choose not to respond', value: 'non-binary' },
]
